import React from "react";
import { useNavigate } from "react-router-dom";
import SVG from "src/utils/SVG";
import IconButton from "./IconButton";

interface IAlarmBtnProps {
  isScrollTop?: boolean;
}

const AlarmButton = (props: IAlarmBtnProps) => {
  const navigate = useNavigate();

  return (
    <IconButton btnName="알림페이지" className="alarm" onClick={() => navigate("/alarm")}>
      {props.isScrollTop ? <SVG name="alarmWhite" /> : <SVG name="alarmBlack" />}
    </IconButton>
  );
};

export default AlarmButton;
